<template>
  <v-flex xs12>
    <v-autocomplete
      :items="rows.filter((x) => x.category.toLowerCase().includes('rate'))"
      item-text="label"
      item-value="id"
      hint="Search for supporting resources"
      label="Related Rate Sheet"
    ></v-autocomplete>
  </v-flex>
</template>

<script>
import { mapActions, createNamespacedHelpers } from "vuex";
import { mapMultiRowFields } from "vuex-map-fields";
import {
  mapDealerPortalFields,
  mapDealerPortalMultiRowFields,
} from "@/store/modules/orders";

const {
  mapActions: mapDealerPortalActions,
  mapMutations: mapDealerPortalMutations,
} = createNamespacedHelpers(`orders/dealerPortal`);
import { httpError } from "@/models/httpError";
import { ResourceFile } from "@/models/ResourceFile";

export default {
  name: "resources-autocomplete",
  props: ["resourceFileID"],
  data: function () {
    return {
      search: "",
      results: [],
      isOpen: false,
      showArchived: false,
    };
  },
  methods: {
    ...mapDealerPortalActions(["getResourceFiles"]),
  },
  computed: {
    ...mapDealerPortalMultiRowFields(["rows"]),
    ...mapDealerPortalFields(["message"]),
  },
  mounted() {
    let vm = this;
    vm.getResourceFiles(vm.showArchived);
  },
};
</script>
